module.exports = __webpack_public_path__ + "static/media/accountTransfer.c6713996.svg";